import { useCallback, useMemo, useState } from 'react'
import clsx from 'clsx'
import { Dropdown, Button } from 'react-bootstrap'

export interface GroupItemOption {
  id: string | number
  label: string
  period?: {
    start?: string
    end?: string
  }
}

export interface GroupItem {
  groupLabel: string
  options: Array<GroupItemOption>
}

export interface GroupDropdownProps {
  value?: string | number
  placeholder?: string
  groupOptions: Array<GroupItem>
  small?: boolean
  type?: string
  onChange: (value: string | number) => void
  disabled?: boolean
}

export const GroupDropdown = ({
  value,
  placeholder,
  groupOptions,
  small,
  type,
  onChange,
  disabled,
}: GroupDropdownProps): JSX.Element => {
  const [show, setShow] = useState<boolean>(false)

  const childOptions = useMemo((): Array<GroupItemOption> => {
    const options = []
    groupOptions.map((group) =>
      group.options.map((option) => options.push(option))
    )
    return options
  }, [groupOptions])

  const toggleView = useMemo((): JSX.Element => {
    const valueLabel = childOptions.find((option) => option.id === value)
    if (valueLabel?.label)
      return <div className="show-data">{valueLabel.label}</div>
    else {
      return (
        <div className="dropdown-placeholder">
          {placeholder ? placeholder : ''}
        </div>
      )
    }
  }, [childOptions, placeholder, value])

  const handleChange = useCallback(
    (selectValue: string | number) => {
      onChange(selectValue)
      setShow(false)
    },
    [onChange]
  )

  const isSelected = useCallback(
    (options: Array<GroupItemOption>): boolean => {
      return !!options.find((item) => item.id === value)
    },
    [value]
  )

  return (
    <div className={clsx(small ? 'dropdown-system-small' : 'dropdown-system')}>
      <Dropdown show={show} onToggle={(nextShow, _) => setShow(nextShow)}>
        {/* placeholder or 選択された時間帯 */}
        <Dropdown.Toggle className={clsx(`dropdown-custom${type ? type : ''}`)} disabled={disabled}>
          {toggleView}
        </Dropdown.Toggle>

        <Dropdown.Menu
          align="start"
          className="dropdown-menu-custom dropdown-menu-custom-child"
        >
          {groupOptions.map(({ groupLabel, options }, index) => (
            <Dropdown key={groupLabel + index} drop="end">
              {/* 料金テーブル名 */}
              <Dropdown.Toggle
                className={clsx(
                  'dropdown-menu-custom-child-toggle',
                  isSelected(options) ? 'selected' : ''
                )}
              >
                {groupLabel}
              </Dropdown.Toggle>
              <Dropdown.Menu className="dropdown-menu-custom-child-menu">
                {/* 料金テーブル時間帯 */}
                {options.map(({ id, label }) => (
                  <Button
                    key={id}
                    onClick={() => handleChange(id)}
                    className={clsx(
                      'dropdown-menu-custom-child-menu-item',
                      value === id ? 'selected' : ''
                    )}
                  >
                    {label}
                  </Button>
                ))}
              </Dropdown.Menu>
            </Dropdown>
          ))}
        </Dropdown.Menu>
      </Dropdown>
    </div>
  )
}
